import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import dashboard from "./dashboard";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    dashboard,
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      // Optional: specify which modules to persist
      paths: ['auth', 'dashboard'],
    }),
  ],
});
